import React from 'react';

interface XIconProps {
  className?: string;
}

function XIcon({ className }: XIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      version="1.2"
      viewBox="0 0 396 396"
      className={className}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M311.9 19h60.7L239.9 170.6 396 376.9H273.8l-95.7-125.1L68.6 376.9H7.8l141.9-162.1L0 19h125.3l86.5 114.4zm-21.3 321.6h33.6L107.1 53.4H70.9z"
      ></path>
    </svg>
  );
}

export default XIcon;
